/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { HttpClient } from "@angular/common/http";
import {EnvironmentService} from "@irian-ro/util-environment";
import {Injectable} from "@angular/core";
import { CompanyType } from '@well/common-libs/legal-entity-management/domain-model';

@Injectable({providedIn: 'root'})
export class InitialRoleAssignmentResourceService {
  url: string | undefined = undefined;

  constructor(private httpClient: HttpClient, private environmentService: EnvironmentService) {
    this.url = environmentService.getEnvironmentProperty('initialRoleAssignmentUrl');
  }

  assignInitialRoleToCurrentUser(companyType: CompanyType){
    return this.httpClient.post(`${this.url}/${companyType}`, {});
  }
}
